import request from '../utils/request'

// 事件列表
export function arsEventListPageApi (data) {
  return request({
    url: 'api/event/listPage',
    method: 'post',
    data
  })
}

// 事件提报 Policy数据
export function arsEventpolicyListApi (data) {
  return request({
    url: 'api/eventPolicy/policyList',
    method: 'post',
    data
  })
}

// 事件提报-NEXA On-Shelf Status数据
export function arsEventUpdateInfoApi (customerId, eventId, params = {}) {
  return request({
    url: `api/event/updateInfo/${customerId}?eventId=${eventId}`,
    method: 'get',
    params
  })
}

// 事件详情 -------------------- start --------------------------------------------
export function arsEventAddEventApi (data) {
  return request({
    url: 'api/event/addEvent',
    method: 'post',
    data
  })
}
export function arsEventUpdateEventApi (data) {
  return request({
    url: 'api/event/updateEvent',
    method: 'post',
    data
  })
}

export function arsEventInfoApi (eventId, schedule = '') {
  return request({
    url: `api/event/info/${eventId}`,
    method: 'get',
    params: {
      schedule
    }
  })
}

export function arsEventFeedbackInfoApi (eventId, schedule = '') {
  return request({
    url: `api/eventFeedback/info/${eventId}?schedule=${schedule}`,
    method: 'get'
  })
}

export function arsEventSellOutGeneralApi (eventId, schedule) {
  return request({
    url: `api/eventSellOut/general/${eventId}?schedule=${schedule}`,
    method: 'get'
  })
}

export function arsEventSellListPageApi (eventId, params) {
  return request({
    url: `api/eventSellOut/listPage?eventId=${eventId}`,
    method: 'get',
    params
  })
}

export function arsEventDeliveryInfoApi (eventId) {
  return request({
    url: `api/eventDelivery/deliveryInfo/${eventId}`,
    method: 'get'
  })
}

export function arsEventSellOutInfoApi (eventId, params) {
  return request({
    url: `api/eventSellOut/info/${eventId}`,
    method: 'get',
    params
  })
}

export function arsEventSellOutAddOrUpdateApi (data) {
  return request({
    url: 'api/eventSellOut/addOrUpdate',
    method: 'post',
    data
  })
}

export function arsEventDeliveryMaterielListPageApi (data) {
  return request({
    url: 'api/eventDelivery/materialListPage',
    method: 'post',
    data
  })
}

export function arsEventDeliveryBatchDeliveryMaterialApi (data) {
  return request({
    url: 'api/eventDelivery/batchDeliveryMaterial',
    method: 'post',
    data
  })
}

export function arsEventFeedbackSummaryApi (eventId) {
  return request({
    url: `api/eventFeedback/summary/${eventId}`,
    method: 'get'
  })
}
// 修改投放样机数量
export function arsEventUdateProtoDeliveryApi (data) {
  return request({
    url: 'api/eventDelivery/updateProtoDelivery',
    method: 'post',
    data
  })
}
// 修改投放物料数量
export function arsEventUdateMaterialDeliveryApi (data) {
  return request({
    url: 'api/eventDelivery/updateMaterialDelivery',
    method: 'post',
    data
  })
}

export function arsEventFeedbackAddOrUpdateApi (data) {
  return request({
    url: 'api/eventFeedback/addOrUpdate',
    method: 'post',
    data
  })
}

export function arsEventSellOutDeleteApi (sellOutId) {
  return request({
    url: `api/eventSellOut/delete/${sellOutId}`,
    method: 'post'
  })
}

export function arsEventCancelApi (eventId) {
  return request({
    url: `/api/event/cancel/${eventId}`,
    method: 'post'
  })
}

// 事件详情 -------------------- end --------------------------------------------

export function eventAddSdEventApi (data) {
  return request({
    url: '/api/event/addSdEvent',
    method: 'post',
    data
  })
}

export function eventUpdateSdEventApi (data) {
  return request({
    url: '/api/event/updateSdEvent',
    method: 'post',
    data
  })
}

export function eventSdFeedbackInfoApi (eventId, schedule = '') {
  return request({
    url: `api/eventSdFeedback/info/${eventId}?schedule=${schedule}`,
    method: 'get'
  })
}

export function eventSdFeedbackSummaryApi (eventId) {
  return request({
    url: `api/eventSdFeedback/summary/${eventId}`,
    method: 'get'
  })
}

export function eventSdFeedbackAddOrUpdate (data) {
  return request({
    url: 'api/eventSdFeedback/addOrUpdate',
    method: 'post',
    data
  })
}

export function eventPolicyInfoApi (policyId) {
  return request({
    url: `api/eventPolicy/info/${policyId}`,
    method: 'post'
  })
}
